import { useEffect, useState } from 'react';

type Args = {
  file: File | null;
};

const useGetImageUrl = ({ file }: Args) => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (!file) {
      return;
    }

    const reader: FileReader | null = new FileReader();
    reader.onloadend = () => {
			// base64のimageUrlを生成する。
      const base64 = reader && reader.result;
      if (base64 && typeof base64 === 'string') {
        setImageUrl(base64);
      }
    };
    reader.readAsDataURL(file);

    /* return () => {
      reader = null;
    }; */
  }, [file]);

  return {
    imageUrl,
  };
};

export default useGetImageUrl;